"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fornovo-di-taro": {
    "adba0518": [{
      "hkey": "e7150ceb",
      "slug": "fornovo-di-taro",
      "name": "Fornovo di Taro",
      "primary": true,
      "skipSearch": false
    }],
    "case-folli": [{
      "hkey": "e7150ceb",
      "slug": "fornovo-di-taro",
      "name": "Fornovo di Taro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fc202aea": [{
      "hkey": "e7150ceb",
      "slug": "fornovo-di-taro",
      "name": "Fornovo di Taro",
      "primary": true,
      "skipSearch": false
    }],
    "selva-smeralda": [{
      "hkey": "e7150ceb",
      "slug": "fornovo-di-taro",
      "name": "Fornovo di Taro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;